import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { onDestroy } from 'svelte';
import { getLanguage, subscribeLanguageChange, t } from '../i18n.ts';
import Button from './svelte-button.svelte';
import DropdownMenu from './svelte-dropdown-menu.svelte';

var root = $.from_html(`<button type="button" class="ui-menu-item" role="menuitem"> </button>`);
var root_1 = $.from_html(`<button type="button" class="ui-menu-item" role="menuitem"> </button> <div class="ui-menu-header"> </div> <!>`, 1);
var root_2 = $.from_html(`<button type="button" class="ui-menu-item" role="menuitem"> </button> <div class="ui-menu-header"> </div> <button type="button" class="ui-menu-item" role="menuitem"> </button> <button type="button" class="ui-menu-item" role="menuitem"> </button> <button type="button" class="ui-menu-item" role="menuitem"> </button>`, 1);
var root_3 = $.from_html(`<!> <!> <!> <!> <!> <input type="file" id="pipeline-file-input" accept=".lutchain,application/x-lutchain" hidden=""/> <!>`, 1);

export default function Svelte_header_action_group($$anchor, $$props) {
	$.push($$props, true);

	const RESET_PRESETS = [
		'StandardToon',
		'HueShiftToon',
		'HueSatShiftToon',
		'Gradient',
		'Plastic',
		'Metallic'
	];

	const canUndo = $.prop($$props, 'canUndo', 7, false),
		canRedo = $.prop($$props, 'canRedo', 7, false);

	function dispatch(eventName, detail) {
		$$props.$$host.dispatchEvent(new CustomEvent(eventName, { detail, bubbles: true, composed: true }));
	}

	let pipelineFileInputRef = $.state(null);
	let language = $.state($.proxy(getLanguage()));

	const disposeLanguageSync = subscribeLanguageChange((nextLanguage) => {
		$.set(language, nextLanguage, true);
	});

	function tr(key, values) {
		$.get(language);

		return values ? t(key, values) : t(key);
	}

	function emitStatus(message, kind = 'info') {
		dispatch('status-message', { message, kind });
	}

	function handleSavePipeline() {
		dispatch('save-pipeline');
	}

	function handleResetPresetSelect(preset) {
		dispatch('reset-preset-selected', { preset });
	}

	function openPipelineFilePicker() {
		if (!$.get(pipelineFileInputRef)) {
			emitStatus(tr('header.status.missingPipelineFileInput'), 'error');

			return;
		}

		$.get(pipelineFileInputRef).click();
	}

	function handlePipelineFileInputChange(event) {
		const input = event.currentTarget;

		if (!input) {
			emitStatus(tr('header.status.pipelineInputMissing'), 'error');

			return;
		}

		const file = input.files?.[0];

		if (!file) {
			input.value = '';

			return;
		}

		if (!(file instanceof File)) {
			emitStatus(tr('header.status.invalidSelectedFile'), 'error');
			input.value = '';

			return;
		}

		if (!Number.isFinite(file.size) || file.size <= 0) {
			emitStatus(tr('header.status.emptyFile'), 'error');
			input.value = '';

			return;
		}

		dispatch('pipeline-file-selected', { file });
		input.value = '';
	}

	function handleExportShaderZip(nextLanguage) {
		dispatch('export-shader-zip', { language: nextLanguage });
	}

	onDestroy(() => {
		disposeLanguageSync();
	});

	var $$exports = {
		get canUndo() {
			return canUndo();
		},

		set canUndo($$value = false) {
			canUndo($$value);
			$.flush();
		},

		get canRedo() {
			return canRedo();
		},

		set canRedo($$value = false) {
			canRedo($$value);
			$.flush();
		}
	};

	var fragment = $.comment();
	var node = $.first_child(fragment);

	$.key(node, () => $.get(language), ($$anchor) => {
		var fragment_1 = root_3();
		var node_1 = $.first_child(fragment_1);

		{
			let $0 = $.derived(() => tr('header.undoAria'));
			let $1 = $.derived(() => !canUndo());

			Button(node_1, {
				variant: 'secondary',
				id: 'btn-undo-pipeline',
				get ariaLabel() {
					return $.get($0);
				},

				get disabled() {
					return $.get($1);
				},
				handlePress: () => dispatch('undo-pipeline'),
				children: ($$anchor, $$slotProps) => {
					$.next();

					var text = $.text();

					$.template_effect(($0) => $.set_text(text, $0), [() => tr('header.undo')]);
					$.append($$anchor, text);
				},
				$$slots: { default: true }
			});
		}

		var node_2 = $.sibling(node_1, 2);

		{
			let $0 = $.derived(() => tr('header.redoAria'));
			let $1 = $.derived(() => !canRedo());

			Button(node_2, {
				variant: 'secondary',
				id: 'btn-redo-pipeline',
				get ariaLabel() {
					return $.get($0);
				},

				get disabled() {
					return $.get($1);
				},
				handlePress: () => dispatch('redo-pipeline'),
				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_1 = $.text();

					$.template_effect(($0) => $.set_text(text_1, $0), [() => tr('header.redo')]);
					$.append($$anchor, text_1);
				},
				$$slots: { default: true }
			});
		}

		var node_3 = $.sibling(node_2, 2);

		{
			const children = ($$anchor, closeMenu = $.noop) => {
				var fragment_4 = root_1();
				var button = $.first_child(fragment_4);
				var text_2 = $.only_child(button, true);
				var div = $.sibling(button, 2);
				var text_3 = $.only_child(div, true);
				var node_4 = $.sibling(div, 2);

				$.each(node_4, 16, () => RESET_PRESETS, (preset) => preset, ($$anchor, preset) => {
					var button_1 = root();
					var text_4 = $.only_child(button_1, true);

					$.template_effect(() => $.set_text(text_4, preset));

					$.delegated('click', button_1, () => {
						closeMenu()();
						handleResetPresetSelect(preset);
					});

					$.append($$anchor, button_1);
				});

				$.template_effect(
					($0, $1) => {
						$.set_text(text_2, $0);
						$.set_text(text_3, $1);
					},
					[
						() => tr('header.resetInitial'),
						() => tr('header.resetExamples')
					]
				);

				$.delegated('click', button, () => {
					closeMenu()();
					handleResetPresetSelect('Initial');
				});

				$.append($$anchor, fragment_4);
			};

			let $0 = $.derived(() => tr('header.reset'));
			let $1 = $.derived(() => tr('header.reset'));

			DropdownMenu(node_3, {
				wrapperClass: 'ui-menu-wrap',
				menuClass: 'ui-menu',
				get triggerAriaLabel() {
					return $.get($0);
				},
				menuRole: 'menu',
				get triggerText() {
					return $.get($1);
				},
				triggerVariant: 'secondary',
				children,
				$$slots: { default: true }
			});
		}

		var node_5 = $.sibling(node_3, 2);

		Button(node_5, {
			variant: 'secondary',
			id: 'btn-load-pipeline',
			handlePress: openPipelineFilePicker,
			children: ($$anchor, $$slotProps) => {
				$.next();

				var text_5 = $.text();

				$.template_effect(($0) => $.set_text(text_5, $0), [() => tr('header.load')]);
				$.append($$anchor, text_5);
			},
			$$slots: { default: true }
		});

		var node_6 = $.sibling(node_5, 2);

		Button(node_6, {
			variant: 'secondary',
			id: 'btn-save-pipeline',
			handlePress: handleSavePipeline,
			children: ($$anchor, $$slotProps) => {
				$.next();

				var text_6 = $.text();

				$.template_effect(($0) => $.set_text(text_6, $0), [() => tr('header.save')]);
				$.append($$anchor, text_6);
			},
			$$slots: { default: true }
		});

		var input_1 = $.sibling(node_6, 2);

		$.bind_this(input_1, ($$value) => $.set(pipelineFileInputRef, $$value), () => $.get(pipelineFileInputRef));

		var node_7 = $.sibling(input_1, 2);

		{
			const children = ($$anchor, closeMenu = $.noop) => {
				var fragment_7 = root_2();
				var button_2 = $.first_child(fragment_7);
				var text_7 = $.only_child(button_2, true);
				var div_1 = $.sibling(button_2, 2);
				var text_8 = $.only_child(div_1, true);
				var button_3 = $.sibling(div_1, 2);
				var text_9 = $.only_child(button_3, true);
				var button_4 = $.sibling(button_3, 2);
				var text_10 = $.only_child(button_4, true);
				var button_5 = $.sibling(button_4, 2);
				var text_11 = $.only_child(button_5, true);

				$.template_effect(
					($0, $1, $2, $3, $4) => {
						$.set_text(text_7, $0);
						$.set_text(text_8, $1);
						$.set_text(text_9, $2);
						$.set_text(text_10, $3);
						$.set_text(text_11, $4);
					},
					[
						() => tr('header.openCode'),
						() => tr('header.downloadZip'),
						() => tr('header.exportShaderZip', { language: 'GLSL' }),
						() => tr('header.exportShaderZip', { language: 'HLSL' }),
						() => tr('header.exportShaderZip', { language: 'MMEffect' })
					]
				);

				$.delegated('click', button_2, () => {
					closeMenu()();
					dispatch('open-shader-dialog');
				});

				$.delegated('click', button_3, () => {
					closeMenu()();
					handleExportShaderZip('glsl');
				});

				$.delegated('click', button_4, () => {
					closeMenu()();
					handleExportShaderZip('hlsl');
				});

				$.delegated('click', button_5, () => {
					closeMenu()();
					handleExportShaderZip('mme');
				});

				$.append($$anchor, fragment_7);
			};

			let $0 = $.derived(() => tr('header.exportMenuAria'));
			let $1 = $.derived(() => tr('header.export'));

			DropdownMenu(node_7, {
				wrapperClass: 'ui-menu-wrap shader-open-button',
				menuClass: 'ui-menu',
				get triggerAriaLabel() {
					return $.get($0);
				},
				menuRole: 'menu',
				get triggerText() {
					return $.get($1);
				},
				triggerVariant: 'submit',
				children,
				$$slots: { default: true }
			});
		}

		$.delegated('change', input_1, handlePipelineFileInputChange);
		$.append($$anchor, fragment_1);
	});

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

$.delegate(['click', 'change']);
customElements.define('lut-header-action-group', $.create_custom_element(Svelte_header_action_group, { canUndo: {}, canRedo: {} }, [], []));